import { observer } from 'mobx-react-lite'
import { ExportJobsDialog } from './ExportJobsDialog'
import { type JobListColumn } from '@/features/jobs/list/job-list-columns'
import { type JobListPageViewModel } from '@/features/jobs/list/JobListPageViewModel'

export interface ExportJobsDialogContainerProps {
  vm: JobListPageViewModel
}

export const ExportJobsDialogContainer = observer(
  function ExportJobsDialogContainer({ vm }: ExportJobsDialogContainerProps) {
    const toOptions = (columns: JobListColumn[]) =>
      columns.map((column) => ({
        id: column.id,
        header: column.header(vm.perspective),
        isSelected: vm.exportSelection.has(column.id),
      }))

    return (
      <ExportJobsDialog
        showing={vm.exportModal.showing}
        onClose={vm.exportModal.close}
        totalJobs={vm.searcher.totalJobs}
        savedFilterName={vm.searcher.savedFilter?.name ?? null}
        shownColumns={toOptions(vm.visibleColumns)}
        moreColumns={toOptions(vm.hiddenColumns)}
        selectedCount={vm.exportColumnCount}
        isExportPending={vm.exportCsv.pending}
        onExport={vm.exportCsv}
        onToggleColumn={vm.toggleExportColumn}
        onSetShownColumns={vm.setVisibleColumnsExported}
        onSetMoreColumns={vm.setHiddenColumnsExported}
      />
    )
  },
)
